export const FILE_STORY_COPY = {
  notCsv: "Only CSV files can be turned into a Story.",
  empty: "That file is empty.",
  noCsvType: "Adding a CSV file isn't available for this organization.",
  uploadFailed: "The file couldn't be uploaded. Please try again.",
  storyFailed: "The Story couldn't be created.",
  adminOnlyHint: "Ask an admin to add this file in Data connectors",
  defaultPromptNoFile: "your file",
} as const;

export const FILE_STORY_PROGRESS_COPY = {
  title: "Turning your file into a Story",
  quoteLabel: "You asked",
  steps: {
    upload: "Uploading the file",
    read: "Reading the file",
    model: "Building the data model",
    story: "Writing your Story",
  },
  rows: (count: number) => `${count.toLocaleString()} rows`,
  unreadable: "The file couldn't be read",
  unreadableFallback: "Check that it is a valid CSV file and try another one.",
  tryAnotherFile: "Try another file",
  uploadHeld: "This file changes the connector's columns, so it waits for a review",
  reviewConnector: "Review in Data connectors",
  modelHeld: "This file changes a large part of the data model, so it waits for a review",
  modelHeldMember: "An admin needs to review it. We'll keep going when it is approved.",
  review: "Review",
  modelFailed: "The data model couldn't be built from this file",
  modelFailedFallback: "You can open the connector, or create the Story on the data you already have.",
  openConnector: "Open the connector",
  createAnyway: "Create the Story anyway",
  timedOut: "Still building. We'll keep going in the background",
  timedOutDetail: "Your data stays in Data connectors. Come back when the model is ready.",
  dataConnectors: "Data connectors",
  storyFailed: "The Story couldn't be created",
  retry: "Retry",
} as const;

export const FILE_STORY_LINK_COPY = {
  incomplete: "This link doesn't point to an uploaded file.",
  backHome: "Back to home",
} as const;
